import { CrewMember } from "../CrewMembers/index.js";
import { CollectionEntity } from "@busy-human/gearbox";
import { Incident } from "../Incidents/index.js";
import { Units } from "../Units/index.js";
import { Users } from "../Users/index.js";
import { Reports } from "../Reports/index.js";
import { RamTemplate } from "../Ram-template/index.js";
import { Messages } from "../Messages/index.js";
import { Aircraft } from "../Aircraft/index.js";
import { LandingZones } from "../LandingZones/index.js";
import { Integration } from "../Integration/index.js";
import { Agency } from "../Agency/index.js";
import { Tasks } from "../Tasks/index.js";
import { CallRequest } from "../CallRequest/index.js";
export var Company;
(function (Company) {
    function Defaults() {
        return {
            active: true,
            companyName: "",
            adminEmail: "",
            commCenterPhone: "",
            address: null,
            adminName: "",
            occRamScore: 0,
            occStatus: false,
            companyCode: "",
            incidentCounter: 0,
            incidentYear: null,
            coordinates: null,
            emailList: null,
            SEData: null,
            guardianTime: null,
            TZ: null
        };
    }
    Company.Defaults = Defaults;
    Company.Relationships = {
        crewMembers: ["crew", CrewMember.CollectionClass],
        incidents: ['incident', Incident.CollectionClass],
        units: ['unit', Units.CollectionClass],
        users: ['users', Users.CollectionClass],
        ramReports: ['ram-report', Reports.CollectionClass],
        oosReports: ['oosReports', Reports.OOSCollectionClass],
        ramTemplates: ['ram-template', RamTemplate.CollectionClass],
        messages: ['messages', Messages.CollectionClass],
        aircraft: ['aircraft', Aircraft.CollectionClass],
        landingZones: ['landing-zones', LandingZones.CollectionClass],
        integrations: ['integrations', Integration.CollectionClass],
        agencies: ['agencies', Agency.CollectionClass],
        tasks: ['tasks', Tasks.CollectionClass],
        callRequests: ['callRequests', CallRequest.CollectionClass]
    };
    class CollectionClass extends CollectionEntity {
        relationships = Company.Relationships;
        defaults() {
            return Defaults();
        }
        async companiesWithInvoice() {
            const docs = await this.subset((ref, query) => query.orderBy('invoiceInfo').toQuery()).fetch();
            return docs.map(d => d.data());
        }
    }
    Company.CollectionClass = CollectionClass;
    Company.Companies = new CollectionClass({ path: "/Companies" });
})(Company || (Company = {}));
//# sourceMappingURL=index.js.map